import { format, parseISO } from 'date-fns'

export function formatDate(iso: string | null | undefined, fmt = 'dd MMM yyyy'): string {
  if (!iso) return '—'
  try {
    return format(parseISO(iso), fmt)
  } catch {
    return '—'
  }
}

export function formatDateTime(iso: string | null | undefined): string {
  return formatDate(iso, 'dd MMM yyyy, h:mm a')
}

/**
 * Currency formatting. Defaults to PKR but accepts the tenant currency.
 */
export function formatCurrency(
  amount: number | null | undefined,
  currency = 'PKR',
): string {
  if (amount === null || amount === undefined) return '—'
  try {
    return new Intl.NumberFormat('en-PK', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(amount)
  } catch {
    return `${currency} ${amount.toLocaleString()}`
  }
}

export function initials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map((w) => w.charAt(0).toUpperCase())
    .join('')
}

/**
 * Format an integer paisa amount as currency (100 paisa = 1 rupee unit).
 * The backend stores monetary lead/order values in paisa to avoid float drift.
 */
export function formatPaisa(paisa: number | null | undefined, currency = 'PKR'): string {
  if (paisa === null || paisa === undefined) return '—'
  return formatCurrency(paisa / 100, currency)
}

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined || bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1)
  return `${(bytes / Math.pow(k, i)).toFixed(i === 0 ? 0 : 1)} ${sizes[i]}`
}
